//DEPENCIES
import { useState } from "react";
import Swal from "sweetalert2";
import moment from "moment-timezone";
//CONTROLLERS
import { putLastReview } from "../../../services/equipmentsAPI";


const ReviewForm = ({control, device, refresh}) => {

  const { reviewFormModalVisible, setReviewFormModalVisible } = control
  const { deviceToReview, setDeviceToReview } = device

  const [newReview, setNewReview] = useState({
    gps_status: null,
    cellular_status: null,
    box_status: null,
    obs:  null
  })

  let new_review_data = {
    equipment_name: deviceToReview?.equipment_name || null,
    user_name: deviceToReview?.user_name || null,
    time_category_name: deviceToReview.time_category_name || null,
    equipment_id: deviceToReview?.equipment_id || null,
    main: deviceToReview?.main || null,
    last_connection: deviceToReview?.last_connection || null,
    last_seen: deviceToReview?.last_seen || null,
    last_reviewed: null,
  }

  const handle_new_review = async () => {

    new_review_data.gps_status = newReview.gps_status
    new_review_data.cellular_status = newReview.cellular_status
    new_review_data.box_status = newReview.box_status
    new_review_data.obs = newReview.obs
    new_review_data.last_reviewed = moment(new Date()).tz("Pacific/Port_Moresby").format("YYYY-MM-DD HH:mm:ss")

    console.log('new review data', new_review_data)

    const result = await Swal.fire({
      title: "Are you sure?",
      html: `
        <p>You are about to save the following review data:</p>
        <ul style="text-align: left; margin-top: 10px;">
          <li><strong>Device:</strong> ${new_review_data.user_name}</li>
          <li><strong>Equipment:</strong> ${new_review_data.equipment_id}</li>
          <li><strong>Gps Status:</strong> ${newReview.gps_status}</li>
          <li><strong>Cellular Status:</strong> ${newReview.cellular_status}</li>
          <li><strong>Box Status:</strong> ${newReview.box_status}</li>
          <li><strong>Observations:</strong> ${newReview.obs}</li>
        </ul>
        <p style="margin-top: 10px;">Do you want to proceed?</p>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save review",
      cancelButtonText: "No",
    });
          
    if (result.isConfirmed) {
      const response  = await putLastReview(new_review_data)
      console.log('response from putLastReview', response)
      if(response.success) {
        Swal.fire({
          title: "Review Saved",
          text: "The review has been successfully saved.",
          icon: "success",
          confirmButtonText: "OK"
        });
        setReviewFormModalVisible(false);
        refresh()
      } else {
        Swal.fire({
          title: "Error Saving Review",
          text: response.message || "An error occurred while saving the review.",
          icon: "error",
          confirmButtonText: "OK"
        });
      }
    }
  }

  if (!reviewFormModalVisible) return null;

  return(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-gray-300 rounded-lg p-6 w-full max-w-3xl shadow-lg">
        <h2 className="text-xl font-bold mb-4">
            Device Health Review
        </h2>
        <div className="mt-22">
          <div className="m-10 bg-gray-300">
            <div className="mx-2 my-5 grid grid-cols-2 gap-4">
              <div className="col-span-1">
                <label className="tracking-wide  text-s font-bold mb-2">
                 {deviceToReview?.equipment_name}
                </label>
              </div>
              <div className="col-span-1">
                <label className="tracking-wide  text-s font-bold mb-2">
                  {deviceToReview?.user_name}
                </label>
              </div>
            </div>
            <div className="mx-2 my-5 grid grid-cols-3 gap-4">
              <div className="col-span-1">
                <label className="tracking-wide text-s font-bold mb-2">
                  GPS Status
                </label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                  value={newReview?.gps_status || "Not Reviewed"}
                  onChange={e =>
                    setNewReview(prev => ({
                      ...prev,
                      gps_status: e.target.value
                    }))
                  }
                >
                  <option value="Not Reviewed">Not Reviewed</option>
                  <option value="Ok">Ok</option>
                  <option value="to Check">to Check</option>
                  <option value="to Change">to Change</option>
                </select>
              </div>
              <div className="col-span-1 align-middle">
                <label className="tracking-wide  text-s font-bold mb-2">
                  Cellular Status
                </label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                  value={newReview?.cellular_status || "Not Reviewed"}
                  onChange={e =>
                    setNewReview(prev => ({
                      ...prev,
                      cellular_status: e.target.value
                    }))
                  }
                >
                  <option value="Not Reviewed">Not Reviewed</option>
                  <option value="Ok">Ok</option>
                  <option value="to Check">to Check</option>
                  <option value="to Change">to Change</option>
                </select>
              </div>
               <div className="col-span-1 align-middle">
                <label className="tracking-wide  text-s font-bold mb-2">
                  Box Status
                </label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                  value={newReview?.box_status || "Not Reviewed"}
                  onChange={e =>
                    setNewReview(prev => ({
                      ...prev,
                      box_status: e.target.value
                    }))
                  }
                >
                  <option value="Not Reviewed">Not Reviewed</option>
                  <option value="Ok">Ok</option>
                  <option value="to Check">to Check</option>
                  <option value="to Change">to Change</option>
                </select>
              </div>
            </div>  
            <div className="mx-2 my-5 grid grid-cols-1 gap-4">
              <div className="col-span-1">
                <label className="tracking-wide text-s font-bold mb-2">
                  Observations
                </label>
                <textarea
                  className="w-full px-3 py-2 border border-gray-300 rounded resize-none h-32"
                  placeholder="Enter your observations here..."
                  value={newReview?.obs || ""}
                  onChange={(e) =>
                    setNewReview(prev => ({
                      ...prev,
                      obs: e.target.value
                    }))
                  }
                />
              </div>
            </div>
            <div className="mx-1 my-15 grid grid-cols-2 gap-4">
              <div className="col-span-1">
                <button
                  className="w-4/5 bg-red-500 text-white px-4 py-2 rounded mr-2"
                  onClick={() => {
                    setReviewFormModalVisible(false);
                    setDeviceToReview(null)
                  }}
                >
                  Cancel
                </button>
              </div>
              <div className="col-span-1">
                <button
                  className={`w-4/5 px-4 py-2 rounded text-white
                    ${!newReview.gps_status || !newReview.cellular_status || !newReview.box_status || !newReview.obs
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-blue-500 hover:bg-blue-600'}
                  `}
                  onClick={handle_new_review}
                  disabled={
                    !newReview.gps_status ||
                    !newReview.cellular_status ||
                    !newReview.box_status ||
                    !newReview.obs
                  }
                  title={
                    !newReview.gps_status ||
                    !newReview.cellular_status ||
                    !newReview.box_status ||
                    !newReview.obs
                      ? 'Please complete all fields including observations'
                      : ''
                  }
                >
                  Save
                </button>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default ReviewForm;